var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.569 4.687c3.58-.4 7.282-.4 10.862 0 1.999.223 3.61 1.797 3.845 3.804.428 3.66.428 7.358 0 11.019-.234 2.006-1.846 3.58-3.845 3.803-3.58.4-7.282.4-10.862 0-1.999-.223-3.61-1.797-3.845-3.803a47.428 47.428 0 0 1 0-11.02c.234-2.006 1.846-3.58 3.845-3.803zM9.88 9.88a.875.875 0 0 1 1.238 0L14 12.763l2.881-2.882a.875.875 0 1 1 1.238 1.238L15.237 14l2.882 2.881a.875.875 0 0 1-1.238 1.238L14 15.237l-2.881 2.882A.875.875 0 1 1 9.88 16.88l2.882-2.88-2.882-2.882a.875.875 0 0 1 0-1.238z",
    fill: "#E80000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.1d599729cacf3b4145a7b526b5c6e2dd.svg";
export { ForwardRef as ReactComponent };